export const ALL_GENRES = [
  'Techno','Rap','House','HipHop','Metal','Pop','Rock','Jazz','Classical',
  'Electro','Lo-Fi','DnB','Soul','Reggae','Country',
];

export const ALL_PRICES = [1, 2, 3];

export const ALL_DRESSCODES = [
  { value: 'egal',      label: 'Egal' },
  { value: 'elegant',   label: 'Elegant' },
  { value: 'fancy',     label: 'Fancy' },
  { value: 'kinky',     label: 'Kinky' },
  { value: 'business',  label: 'Business Casual' },
  { value: 'sportlich', label: 'Sportlich' },
  { value: 'costume',   label: 'Costume' },
];

export const ALL_SPECIAL_TYPES = [
  { value: 'pride',     label: 'Pride' },
  { value: 'uni',       label: 'Uni / Student' },
  { value: 'sport',     label: 'Sport' },
  { value: 'glam',      label: 'Glam' },
  { value: 'food',      label: 'Food & Culinary' },
  { value: 'art',       label: 'Art & Culture' },
  { value: 'market',    label: 'Market / Festival' },
  { value: 'family',    label: 'Family' },
  { value: 'rave',      label: 'Rave' },
  { value: 'afterwork', label: 'Afterwork' },
  { value: 'concert',   label: 'Concert' },
  { value: 'karaoke',   label: 'Karaoke' },
  { value: 'pubquiz',   label: 'Pub Quiz' },
  { value: 'other',     label: 'Other' },
];
